"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ConfirmAccount["default"];
  }
});
var _ConfirmAccount = _interopRequireDefault(require("./ConfirmAccount"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }